module.exports = __webpack_public_path__ + "static/media/skopei-360-inline.b105cb35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/skopei-360-inline.svg
// module id = 575
// module chunks = 14